import {Component, Inject, OnInit, Optional} from '@angular/core';
import {FormBuilder, FormsModule, ReactiveFormsModule, UntypedFormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatOptionModule} from '@angular/material/core';
import {MatButtonModule} from '@angular/material/button';
import {CommonModule} from '@angular/common';
import {VerbalActionCategoryService} from '../../../../services/verbal-action/verbal-action-category.service';
import {NotificationService} from '../../../../services/common/notification.service';
import {SelectDialogComponent} from '../../../select/select-dialog/select-dialog.component';
import {CategoryCreationDto} from "../../../../dtos/verbal-action/category/category-creation-dto";

export interface NewVerbalActionCategoryDialogData {
  id?: number;
}

@Component({
  selector: 'app-new-verbal-action-category',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatDialogModule,
    MatButtonModule,
  ],
  templateUrl: './new-verbal-action-category.component.html',
  styleUrl: './new-verbal-action-category.component.scss',
  standalone: true
})
export class NewVerbalActionCategoryComponent implements OnInit {

  formGroup!: UntypedFormGroup;
  selectedParentCategory: {id: number; name: string} | null = null;
  edit = false;
  id: number | null = null;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<NewVerbalActionCategoryComponent>,
    private categoryService: VerbalActionCategoryService,
    private notificationService: NotificationService,
    private dialog: MatDialog,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: NewVerbalActionCategoryDialogData
  ) {}

  ngOnInit(): void {
    this.formGroup = this.fb.group({
      name: ['', Validators.required],
      parentId: [{value: null, disabled: true}]
    });

    if (this.data?.id) {
      this.edit = true;
      this.id = this.data.id;
      this.categoryService.getCategory(this.id).subscribe({
        next: (cat) => {
          this.formGroup.patchValue({name: cat.name});
          if (cat.parent) {
            this.selectedParentCategory = {id: cat.parent.id, name: cat.parent.name};
            this.formGroup.controls['parentId'].setValue(cat.parent.id);
          }
        },
        error: (err) => this.notificationService.openSnackBar(err)
      });
    }
  }

  openParentCategorySelect(): void {
    const dialogRef = this.dialog.open(SelectDialogComponent, {
      data: {
        selectedObject: this.selectedParentCategory,
        displayedColumns: ['single-select', 'voc-cat-name', 'voc-cat-parent'],
        selectionEntity: 'va_category',
        dialogTitle: 'Übergeordnetes Thema auswählen',
        selectionMode: 'single-select',
        excludedId: this.id
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        if (result && result.length > 0) {
          this.selectedParentCategory = result[0];
          this.formGroup.controls['parentId'].setValue(result[0].id);
        } else {
          this.selectedParentCategory = null;
          this.formGroup.controls['parentId'].setValue(null);
        }
      }
    });
  }

  save(): void {
    if (this.formGroup.controls['name'].invalid) return;
    const dto = new CategoryCreationDto(
      this.id,
      this.formGroup.value.name,
      this.selectedParentCategory?.id ?? null,
      [], [], [], [], [], [], [], [], [], [], [], [], [], []
    );

    const request = this.edit
      ? this.categoryService.updateCategory(this.id, dto)
      : this.categoryService.createCategory(dto);

    request.subscribe({
      next: (result) => {
        this.notificationService.openSnackBar(
          'Thema "' + result.name + '" erfolgreich ' + (this.edit ? 'aktualisiert' : 'erstellt')
        );
        this.dialogRef.close(true);
      },
      error: (err) => this.notificationService.openSnackBar(err)
    });
  }
}
